import { Progress } from 'antd';

const BlinketLogoDark = 'https://cdn.eduzzcdn.com/blinket/blinket-logo-dark-v2.svg';

const GlobalLoading = () => {
  return (
    <div
      id='page-loader'
      className='fixed inset-0 z-(--uizz-antd-z-index-popup-base) flex items-center justify-center bg-(--uizz-antd-color-bg-mask) backdrop-blur-sm'
    >
      <div className='-mt-5 flex w-80 flex-col items-center justify-center'>
        <img src={BlinketLogoDark} alt='Logo' className='mb-5 w-[256px]' />
        <Progress percent={100} status='active' showInfo={false} />
      </div>
    </div>
  );
};

export default GlobalLoading;
